import { type FC, type ReactNode } from 'react';
import { priceEstimatePill } from '../pdpMessages.tsx';
import { Badge } from 'dibs-elements/exports/Badge.tsx';
import styles from './PdpSharedSimilarSoldItemsDetailsCell.module.css';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

export const PdpSharedSimilarSoldItemsDetailsCell: FC<{
    entry?: string;
    label: ReactNode;
    value?: ReactNode;
    isLastItem?: boolean;
    isCurrentItem?: boolean;
    isBelowEstimate?: boolean;
}> = ({ entry, label, value, isCurrentItem, isBelowEstimate, isLastItem }) => {
    const isDimensionsField = entry === 'DIMENSIONS';
    const isPriceField = entry === 'PRICE';

    return (
        <div
            className={classnames(
                dibsCss.mtXxsmall,
                dibsCss.ptXxsmall,
                dibsCss.borderT,
                dibsCss.borderTSolid,
                dibsCss.borderDolphin,
                { [dibsCss.mlXsmall]: isCurrentItem, [dibsCss.mrXsmall]: isLastItem }
            )}
        >
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.flexCol,
                    dibsCss.pxXsmall,
                    dibsCss.relative,
                    {
                        [styles.priceCellHeight]: isPriceField,
                        [dibsCss.plNone]: isCurrentItem,
                        [dibsCss.prNone]: isLastItem,
                    }
                )}
            >
                <span
                    className={classnames(dibsCss.sassyFontBodyXSmall, {
                        [dibsCss.textSatan]: !isPriceField,
                        [dibsCss.textInternalsecondary]: isCurrentItem && isPriceField,
                        [dibsCss.textMarketingsale]: !isCurrentItem && isPriceField,
                    })}
                >
                    {label}
                </span>
                <span
                    title={typeof value === 'string' ? value : undefined}
                    className={classnames(dibsCss.sassyFontBodyMedium, dibsCss.textNoir, {
                        [dibsCss.lineClamp1]: !isDimensionsField,
                        [dibsCss.lineClamp2]: isDimensionsField,
                        [dibsCss.sassyFontBodyMediumHeavy]: isPriceField,
                        [dibsCss.textSatan]: !isCurrentItem && isPriceField,
                    })}
                >
                    {value || '--'}
                </span>
                {isCurrentItem && isPriceField && (
                    <div className={classnames(dibsCss.absolute, dibsCss.bottom0)}>
                        <Badge type="pill" size="small-heavy" backgroundColor="green-50">
                            {priceEstimatePill({ isBelowMinPriceEstimate: !!isBelowEstimate })}
                        </Badge>
                    </div>
                )}
            </div>
        </div>
    );
};
